var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.tariffName))]),(_vm.getTariffEndDate)?_c('span',[_vm._v(", "+_vm._s(_vm.$t('message.tariff.endDate', {date: _vm.getTariffEndDate})))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }